import { actions } from './actions';
import * as sagas from './sagas';
export const folderModel = { actions, sagas };
